import React from 'react';
import { CompanyLogo } from '@components';
import { useStore } from '@hooks';
import { Typography } from '@ui';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

const Welcome = observer(() => {
    const store = useStore();
    const { firstName, lastName } = store.authStore;

    return (
        <Row align='middle' gutter={[16, 16]}>
            <Col>
                <CompanyLogo showEditButton={false} />
            </Col>
            <Col>
                <Typography.Title data-e2e='home_welcome_title' marginBottom='0' level={2}>
                    Welcome, {firstName} {lastName}
                </Typography.Title>
            </Col>
        </Row>
    );
});

export default Welcome;
